import { render, staticRenderFns } from "./TrialStatusIcon.vue?vue&type=template&id=6ef5c824&scoped=true&"
import script from "./TrialStatusIcon.vue?vue&type=script&lang=js&"
export * from "./TrialStatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./TrialStatusIcon.vue?vue&type=style&index=0&id=6ef5c824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef5c824",
  null
  
)

export default component.exports